import React from 'react'
import {useDividerStyle} from '../../styles/useStyles'

const DividerWithText = ({children}: {children: React.ReactNode}) => {
  const classes = useDividerStyle()
  return (
    <div className={classes.container}>
      <div className={classes.borderLeft} />
      <span className={classes.content}>{children}</span>
      <div className={classes.borderRight} />
    </div>
  )
}
export default DividerWithText
